var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-item",
    { on: { click: _vm.selectCulture } },
    [
      _c(
        "v-list-item-avatar",
        [_c("v-img", { attrs: { src: _vm.langImageUrl } })],
        1
      ),
      _vm._v(" "),
      _c("v-list-item-content", [
        _vm._v("\n            " + _vm._s(_vm.displayName) + "\n        "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }